import type { LevelDto } from '@internal/scorecards-common';
import { useEffect, useState } from 'react';

import { scorecardsApiRef } from '../api/ScorecardsApi';
import { useApi } from '@backstage/core-plugin-api';

export function useLevels(): {
  levels: LevelDto[];
  loading: boolean;
} {
  const api = useApi(scorecardsApiRef);
  const [levels, setLevels] = useState<LevelDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .getLevels()
      .then(result => {
        if (!cancelled) setLevels(result.filter(l => l.active));
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [api]);

  return { levels, loading };
}
